import router from "../router/";
import $config from "@/config/baseConfig";

/**
 * @description: 路由跳转
 */
export const jump = (name, query = {}, params = {}) => {
  router.push({
    name: name,
    query: query,
    params: params,
  });
};

/**
 * @description: tree转数组
 * @param {type}
 * @return:
 * @use:
 */
export const treeTransArray = (tree, key) => {
  return [].concat(
    ...tree.map(item => {
      if (item[key] && item[key].length) {
        return [].concat(item, ...treeTransArray(item[key]), key);
      } else {
        return item;
      }
    }),
  );
};

/**
 * @description: 获取头像
 * @param {type}
 * @return:
 * @use:
 */
export const getAvatarUrl = url => {
  if (url) {
    return $config.fileUrl + url;
  } else {
    return "/images/avatar.jpg";
  }
};
export const hasClass = (elements, cName) => {
  return !!elements.className.match(new RegExp("(\\s|^)" + cName + "(\\s|$)"));
};
export const addClass = (elements, cName) => {
  if (!hasClass(elements, cName)) {
    elements.className += " " + cName;
  }
};
export const removeClass = (elements, cName) => {
  if (hasClass(elements, cName)) {
    elements.className = elements.className.replace(
      new RegExp("(\\s|^)" + cName + "(\\s|$)"),
      " ",
    );
  }
};
export const checkPhone = phone => {
  const tel = phone && phone.trim();
  let val = tel;
  if (tel && tel.length >= 11) {
    val = tel.substring(tel.length - 11);
  }
  if (val && !/^1[3456789]\d{9}$/.test(val)) {
    return false;
  } else {
    return true;
  }
};
export const accAdd = (arg1, arg2) => {
  var r1, r2, m, c;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  c = Math.abs(r1 - r2);
  m = Math.pow(10, Math.max(r1, r2));
  if (c > 0) {
    var cm = Math.pow(10, c);
    if (r1 > r2) {
      arg1 = Number(arg1.toString().replace(".", ""));
      arg2 = Number(arg2.toString().replace(".", "")) * cm;
    } else {
      arg1 = Number(arg1.toString().replace(".", "")) * cm;
      arg2 = Number(arg2.toString().replace(".", ""));
    }
  } else {
    arg1 = Number(arg1.toString().replace(".", ""));
    arg2 = Number(arg2.toString().replace(".", ""));
  }
  return (arg1 + arg2) / m;
};
export const accSub = (arg1, arg2) => {
  var r1, r2, m, n;
  try {
    r1 = arg1.toString().split(".")[1].length;
  } catch (e) {
    r1 = 0;
  }
  try {
    r2 = arg2.toString().split(".")[1].length;
  } catch (e) {
    r2 = 0;
  }
  m = Math.pow(10, Math.max(r1, r2)); //last modify by deeka //动态控制精度长度
  n = r1 >= r2 ? r1 : r2;
  return ((arg1 * m - arg2 * m) / m).toFixed(n);
};
export const accMul = (arg1, arg2) => {
  var m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString();
  try {
    m += s1.split(".")[1].length;
    // eslint-disable-next-line no-empty
  } catch (e) {}
  try {
    m += s2.split(".")[1].length;
    // eslint-disable-next-line no-empty
  } catch (e) {}
  return (
    (Number(s1.replace(".", "")) * Number(s2.replace(".", ""))) /
    Math.pow(10, m)
  );
};

//除法函数
export const accDiv = (arg1, arg2) => {
  var t1 = 0,
    t2 = 0,
    r1,
    r2;
  try {
    t1 = arg1.toString().split(".")[1].length;
    // eslint-disable-next-line no-empty
  } catch (e) {}
  try {
    t2 = arg2.toString().split(".")[1].length;
    // eslint-disable-next-line no-empty
  } catch (e) {}

  r1 = Number(arg1.toString().replace(".", ""));

  r2 = Number(arg2.toString().replace(".", ""));
  return (r1 / r2) * Math.pow(10, t2 - t1);
};

export const delUrlParam = name => {
  let queryJson = {};
  var urlParam = decodeURIComponent(window.location.search); //页面参数
  let arr = [],
    searchParam = "";
  if (urlParam.indexOf("?") != -1) {
    const param = urlParam.substr(1);
    if (param) {
      var urlParamArr = param.split("&"); //将参数按照&符分成数组
      for (var i = 0; i < urlParamArr.length; i++) {
        var paramArr = urlParamArr[i].split("="); //将参数键，值拆开
        //如果键与要删除的不一致，则加入到参数中
        if (paramArr[0] != name) {
          queryJson[paramArr[0]] = paramArr[1];
          arr.push(urlParamArr[i]);
        }
      }
    }
  }
  if (arr.length > 0) {
    searchParam = "?" + arr.join("&");
  }
  return { queryJson, searchParam };
};
export const trimStr = str => {
  return str.replace(/(^\s*)|(\s*$)/g, "");
};

/**
 * 生成一个 不重复的ID
 * @param { Number } randomLength
 */
export const getUid = (randomLength = 36) => {
  return Number(
    Math.random()
      .toString()
      .substr(2, randomLength) + Date.now(),
  ).toString(36);
};
